<template>
	<div id="notepad">
		<div id="notepad_wrapper">
			<h3 style="margin-bottom:30px">Notepad</h3>
			<b-container v-if="doubts_with_notes.length == 0">
				<h5>You have not added any notes!</h5>
				<p>After your doubt is solved, you can add a note below the solution for future reference.</p>
				<p>To add a note, go to your Solutions and add a note there.</p>
			</b-container>
			<b-container fluid class="solution-container" v-for="(doubt,index) in doubts_with_notes" :key="doubt.id">
				<div class="material-section" @click="open_doubt(doubt.id)">
					<span class="info">Added on Doubt <b-link :to="
				'/dashboard/doubts/'+doubt.id" class="proper_link">({{doubt.title}})</b-link></span>
					<p>{{doubt.note_text}}</p>
				</div>
			</b-container>
		</div>
	</div>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'Notepad',
  data () {
    return {
      msg: 'Welcome to QdsPro',
      enable_filters:false
    }
  },
  computed: {
    user: function() {
      return this.$store.getters.user
    },
    doubts_with_notes: function() {
    	var filtered = [];

    	filtered = _.filter(this.user.doubts, function(o) {
    		if(o.hasOwnProperty('note_text')) {
    			return true;
    		}
    	});

    	return filtered;
    }

  },
  methods: {
    get_human_date(d) {
      let mom = moment(d);
      return mom.format('LL');
		},
		open_doubt(id) {
			this.$router.push('/dashboard/doubts/'+id);
		}
  },
  async mounted() {
  	var action2 = await this.$store.dispatch('fetch_doubts');
  }
}
</script>

<style scoped>
.material-section {
	padding: 20px;
	background-color: white;
	box-shadow: 0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);
	border-radius: 5px;
	margin-top: 10px;
	cursor:pointer;
}
.material-section p {
	margin-bottom: 0;
	color: black;
	margin-top: 10px;
}
.material-section span.info {
	color: #696969;
	font-size:0.8rem;
}

.material-section span.info .proper_link {
	color: #4D4D94;
	text-decoration: underline;
}

</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Notepad.vue